import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import { ACL } from "src/components/acl";
import { Subheading } from "src/components/base/heading";
import { useTranslation } from "react-i18next";
import SINGLE_TAG_CONTEXT from "src/context/internal/tag";
import ReadOnlyRuleSets from "src/components/rulesets";

/**
 * The properties for {@link TagInboundACLs}
 */
export type TagInboundACLsProps = {};

/**
 * The view to display the Inbound ACLs of a tag
 */
function TagInboundACLs(props: TagInboundACLsProps) {
    const [t] = useTranslation("admin-tag");

    const ctx = React.useContext(SINGLE_TAG_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            {ctx.tag.locked ? undefined : (
                <>
                    <Subheading>{t("heading.add-new-acl")}</Subheading>
                    <ACL
                        key={"new-inbound"}
                        onChange={ctx.reset}
                        dst={{ type: "Tag", value: ctx.tag }}
                        startEditable={true}
                    />
                </>
            )}
            <Subheading>{t("heading.existing-acls")}</Subheading>
            {ctx.tag.access_rules.inbound.map((acl) => (
                <ACL key={acl.uuid} dst={acl.dst} acl={acl} onChange={ctx.reset} />
            ))}
            <Subheading>{t("heading.rulesets")}</Subheading>
            {ctx.tag.rulesets.inbound.map((ruleset) => (
                <ReadOnlyRuleSets
                    key={ruleset.uuid}
                    name={ruleset.name}
                    description={ruleset.description}
                    rules={ruleset.rules}
                    destinations={ruleset.src_or_dst}
                />
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/tags/$tagId/_tags/inbound-acls")({
    component: TagInboundACLs,
});
